export default {
  goTo: {
    en: '“{pageName}” page',
  },
}
